import React, { useEffect, useState } from "react";
import { fetchMeetupspagepastlist } from "../services/Meetupspagepastlist";
import { API_BASE } from "../api/apiConfig";

const Meetupspagepastlistdata = () => {
  const [upcomingmeetups, setupcomingmeetups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadupcomingmeetups();
  }, []);

  const loadupcomingmeetups = async () => {
    try {
      const res = await fetchMeetupspagepastlist();
      console.log("🔥 API RESPONSE:", res);

      setupcomingmeetups(res.data);

    } catch (err) {
      console.error("❌ API ERROR:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p className="text-center py-10">No past meetups found</p>;
  }

  return (
   <div className="grid gap-6 md:grid-cols-3">
    {upcomingmeetups.map(upcomingdata => (
    <div className="rounded-lg text-card-foreground overflow-hidden border border-slate-200 bg-white shadow-sm">
      <div className="relative h-48 w-full">
        <img
          alt={upcomingdata.city}
          loading="lazy"
          decoding="async"
          data-nimg="fill"
          className="object-cover"
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            inset: 0,
            color: "transparent"
          }}
          src={`${API_BASE}/${upcomingdata.image}`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
        <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute right-3 top-3 bg-white/90 text-slate-800">
          {upcomingdata.city}
        </div>
        {/*<div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute left-3 top-3 bg-primary/90 text-white">
          Sightseeing
        </div>*/}
      </div>
      <div className="p-4">
        <h3 className="mb-2 text-lg font-medium text-slate-800">
          {upcomingdata.heading}
        </h3>
        <div className="mb-4 space-y-2 text-sm">
          <div className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-calendar h-4 w-4 text-primary"
            >
              <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
              <line x1={16} x2={16} y1={2} y2={6} />
              <line x1={8} x2={8} y1={2} y2={6} />
              <line x1={3} x2={21} y1={10} y2={10} />
            </svg>
            <span className="text-slate-600">{upcomingdata.date}</span>
          </div>
          <div className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-map-pin h-4 w-4 text-primary"
            >
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
              <circle cx={12} cy={10} r={3} />
            </svg>
            <span className="text-slate-600">{upcomingdata.city}</span>
          </div>
          {/*<div className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users h-4 w-4 text-primary"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span className="text-slate-600">32 attendees</span>
          </div>*/}
        </div>
        <div className="rounded-lg bg-slate-50 p-3">
          <p className="mb-2 text-sm italic text-slate-600" dangerouslySetInnerHTML={{ __html: upcomingdata.about }}>
          </p>
        {upcomingdata.local_experts_details && upcomingdata.local_experts_details.length > 0 && (
          <p className="text-xs font-medium text-primary">— {upcomingdata.local_experts_details[0].name}</p>
        )}
        </div>
      </div>
    </div>
    ))}
  </div>
  );
};

export default Meetupspagepastlistdata;
